import { ConsultantTypeGroup } from '../../../enums';

export const getVariantForTypeName = (typeName: string) => {
  if (typeName.toLowerCase() === 'architect') return ConsultantTypeGroup.Architect;
  if (typeName.toLowerCase().includes('engineer')) return ConsultantTypeGroup.Engineer;
  return ConsultantTypeGroup.Other;
};
